module.exports = __webpack_public_path__ + "img/qna_post.136e00e.png";